import { VIEW_ALL_BUILDING } from '@studio/atomic-ui'
import { baseUrl } from '../../env'

export const getBuildingHolidays = async ({ building }: { building: string }) => {
  if (!building || building === VIEW_ALL_BUILDING.value) return

  const url = new URL('api/holidays', baseUrl)
  url.searchParams.set('building', building)

  const response = await fetch(url)

  if (response.status !== 200) return

  const text = await response.text()
  if (!text) return

  try {
    return JSON.parse(text)
  } catch {
    return
  }
}
